import { Link } from 'react-router-dom';

const stats = [
  { value: '2,600+', label: '影视视频资源' },
  { value: '9', label: '内容分类专题' },
  { value: '18万+', label: '社区互动用户' },
  { value: '7×24', label: '内容持续更新' },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="grid grid-cols-1 items-center gap-10 rounded-lg border border-background-200/70 bg-background-50 p-6 md:grid-cols-2 md:p-10">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-information-line" />
            关于平台
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-900 md:text-3xl">
            一个清晰、丰富、好用的娱乐资源平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-500 md:text-base">
            麻豆精品入口蜜桃致力于为喜爱影视与高清视频的用户提供内容展示与探索体验。我们以「现代门户 + 专业资料」的浏览方式，整合影视、短视频与直播专区内容，
            配合多维筛选、全文搜索与轻量社交互动，让每一次浏览都高效又轻松。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-lg" />
              开始探索
            </Link>
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              了解我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200/70 bg-background-100 p-5 text-center"
            >
              <p className="font-heading text-2xl font-black text-primary-500 md:text-3xl">{stat.value}</p>
              <p className="mt-2 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}